import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FailureComponent } from "app/modals/failure/failure.component";
import { environment } from "environments/environment";
import moment from 'moment';

@Injectable({
  providedIn: "root",
})
export class GlobalService {
  getSet: any;
  productType = environment.productTypes;
  addOnCats = environment.addonCategory;
  constructor(public modalService: NgbModal) {}

  get getterSetter(): any {
    return this.getSet;
  }
  set getterSetter(x: any) {
    this.getSet = x;
  }

  //Creating and Initializing Error Modal
  failureErrorModal(message: any) {
    const modalRef = this.modalService.open(FailureComponent, {
      centered: true,
    });

    modalRef.componentInstance.failureContent = {
      title: "Oops! Something Went Wrong.",
      message: message,
      btnText: "Close",
    };
  }
  dateFromJsonToString(date, separator = "/") {
    if (date["year"]) {
      return moment(
        new Date(date["year"], date["month"] - 1, date["day"])
      ).format("YYYY" + separator + "MM" + separator + "DD");
    } else {
      return moment(new Date()).format("YYYY/MM/DD");
    }
  }
  dateFromJsonToString_modified(date) {
    if (date["year"]) {
      return moment(
        new Date(date["year"], date["month"] - 1, date["day"])
      ).format();
    } else {
      return moment(new Date()).format();
    }
  }

  dateFromStringToJson(date: string) {
    var check = moment(date, "YYYY/MM/DD");
    var month = check.format("M");
    var day = check.format("D");
    var year = check.format("YYYY");
    return { year: parseInt(year), month: parseInt(month), day: parseInt(day) };
  }

    toggleActions(i) {
    document.getElementById("actions" + i).classList.toggle("d-none");
  }

  filterAddonCategory(term) {
    let cat: any;
    cat = this.addOnCats.filter((x) => x.id === term);
    return cat[0].name;
  }

  // Download the converted CSV

  downloadFile(data, filename = "customer_data") {
    let csvData = this.ConvertToCSV(data, [
      "name",
      "emailID",
      "contactNumber",
      "registered_at",
    ]);
    // console.log(csvData);
    let blob = new Blob(["\ufeff" + csvData], {
      type: "text/csv;charset=utf-8;",
    });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser =
      navigator.userAgent.indexOf("Safari") != -1 &&
      navigator.userAgent.indexOf("Chrome") == -1;
    if (isSafariBrowser) {
      //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  // Convert Array of JSON to CSV

  ConvertToCSV(objArray, headerList) {
    let array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    let str = "";
    let row = "S.No,";

    for (let index in headerList) {
      row += headerList[index] + ",";
    }
    row = row.slice(0, -1);
    str += row + "\r\n";
    for (let i = 0; i < array.length; i++) {
      let line = i + 1 + "";
      for (let index in headerList) {
        let head = headerList[index];

        line += "," + array[i][head];
      }
      str += line + "\r\n";
    }
    return str;
  }
  
  cleanObject(obj: Object) {
    return JSON.parse(JSON.stringify(obj));
  }
}
